import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';

export default function EmployeePhoto({ src, name = '', className = 'h-8 w-6', fullHeight = false }) {
  if (!src) return null;
  if (fullHeight) return (
    <span className="relative w-8 shrink-0 self-stretch overflow-hidden">
      <Avatar className="absolute inset-0 h-full w-full rounded-none">
        <AvatarImage src={src} alt={`Foto von ${name}`} className="aspect-auto object-cover" />
        <AvatarFallback className="rounded-none text-[9px]">{name.split(' ').filter(Boolean).map(part => part[0]).slice(0, 2).join('')}</AvatarFallback>
      </Avatar>
    </span>
  );
  return (
    <Avatar className={`${className} shrink-0 rounded-none`}>
      <AvatarImage src={src} alt={`Foto von ${name}`} className="aspect-auto object-contain" />
      <AvatarFallback className="rounded-none text-[9px]">{name.split(' ').filter(Boolean).map(part => part[0]).slice(0, 2).join('')}</AvatarFallback>
    </Avatar>
  );
}
